
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class AdminMenu extends Vue {
  adminRoles: any = [];
  isReinsurer = true;

  async mounted() {
    await this.loadAdminRoles();
    if (this.$store.state.user)
      this.isReinsurer =
        this.$store.state.user.type == this.adminRoles.REASEGURADOR;
  }

  async loadAdminRoles() {
    const response: any = await (this.$root as any)._get("admins/getroles");
    this.adminRoles = response;
  }

  async exportReportedClaims() {
    const response: any = await (this.$root as any)._get(
      "claims/exportreportedclaims"
    );
    if (response.path) {
      window.open(response.path);
    }
  }

  async exportRequests() {
    const response: any = await (this.$root as any)._post(
      "requests/exportxls",
      {}
    );
    if (response.path) {
      window.open(response.path);
    }
  }

  async exportBorderaux() {
    const response: any = await (this.$root as any)._get(
      "claims/exportborderaux"
    );
    if (response.path) {
      window.open(response.path);
    }
  }
}
